import { all, call, put, select, takeEvery } from 'redux-saga/effects';

import session from 'containers/App/session';
import { withApiErrorHandling } from 'utils/redux/sagaHelper';
import { statsService } from 'utils/api';

import { FETCH_SAVES, LOAD_SAVE, SAVE_FORM } from './constants';
import {
    fetchSavesStarted,
    fetchSavesSucceeded,
    fetchSavesFailed,
    loadSaveStarted,
    loadSaveSucceeded,
    loadSaveFailed,
    saveFormStarted,
    saveFormSucceeded,
    saveFormFailed,
} from './actions';

function* fetchSavesSaga(action) {
    try {
        const { params } = action;
        const { type, propertyId, userId } = params;
        yield put(fetchSavesStarted(params));

        const token = yield select(session.selectors.selectUserToken);

        const { response, error } = yield call(withApiErrorHandling, statsService({ token }).getAllSaves, {
            type,
            propertyID: propertyId,
            userID: userId,
        });
        if (response) {
            yield put(fetchSavesSucceeded(response.data));
        } else {
            yield put(fetchSavesFailed(error));
        }
    } catch (error) {
        yield put(fetchSavesFailed(error));
    }
}

function* loadSaveSaga(action) {
    try {
        const { params } = action;
        const { saveID } = params;
        yield put(loadSaveStarted(params));

        const token = yield select(session.selectors.selectUserToken);

        const { response, error } = yield call(
            withApiErrorHandling,
            statsService({ token, resourceId: saveID }).getSaveById,
        );
        if (response) {
            yield put(loadSaveSucceeded(response.data));
        } else {
            yield put(loadSaveFailed(error));
        }
    } catch (error) {
        yield put(loadSaveFailed(error));
    }
}

function* saveFormSaga(action) {
    try {
        const { params } = action;
        const { saveID, type, propertyId, payload } = params;
        yield put(saveFormStarted(params));

        const token = yield select(session.selectors.selectUserToken);

        let response;
        let error;
        if (saveID) {
            ({ response, error } = yield call(
                withApiErrorHandling,
                statsService({ token, resourceId: saveID }).updateSave,
                payload,
            ));
        } else {
            ({ response, error } = yield call(withApiErrorHandling, statsService({ token }).createSave, {
                type,
                propertyID: propertyId,
                ...payload,
            }));
        }
        if (response) {
            yield put(saveFormSucceeded(response.data));
        } else {
            yield put(saveFormFailed(error));
        }
    } catch (error) {
        yield put(saveFormFailed(error));
    }
}

export default function* watchSaga() {
    yield all([
        takeEvery(FETCH_SAVES, fetchSavesSaga),
        takeEvery(LOAD_SAVE, loadSaveSaga),
        takeEvery(SAVE_FORM, saveFormSaga),
    ]);
}
